export const convertCurrency = (value: number) => {
  return parseFloat(parseFloat(value.toString()).toFixed(2)).toLocaleString(
    "es-MX",
    { minimumFractionDigits: 2 },
  );
};
